import * as qz from "qz-tray";

const getPrinterConfig = (settingsData) => {
  let config = null;

  // const deviceName = "Generic / Text Only";
  const deviceName = settingsData.printerName || "";

  if (!deviceName) {
    return null;
  }

  config = qz.configs.create(deviceName, {
    encoding: null,
    protocol: "RAW",
  });

  return config;
};

export const getPrinterList = async () => {
  try {
    // Get list of available printers

    await new Promise((res) => setTimeout(res, 500)); // 500ms delay

    const printers = await qz.printers.find();

    if (!printers.length) {
      return {
        message: "Printer not found.",
        printerList: [],
        connectionType: "",
      };
    }

    return {
      message: "",
      printerList: printers,
      connectionType: "",
    };
  } catch (err) {
    console.error("Error while", err);

    return {
      message: "Printer not found.",
      printerList: [],
      connectionType: "",
    };
  }
};

export const testPrinterConnection = async (settingsData, receivePrinterObj, showNotification) => {
  try {
    console.log("****testPrinterConnection****", { settingsData, receivePrinterObj });

    const config = getPrinterConfig(settingsData);

    if (!config) {
      showNotification("No printer name provided.");
      return;
    }

    const data = [
      {
        type: "raw",
        format: "plain",
        data:
          "\x1B\x40" + // Initialize printer
          "Printer connection successfull.\n\n" +
          "Thank you!\n\n\n" +
          "\x1D\x56\x41\x10", // Full paper cut
      },
    ];

    await qz.print(config, data);
  } catch (err) {
    console.log("err", err);
    showNotification(err.message);
  }
};

export const testCashDrawerOpen = async(settingsData, cashDrawerCommand, showNotification) => {
  try {
    const config = getPrinterConfig(settingsData);

    if (!config) {
      showNotification("No printer name provided.");
      return;
    }

    const data = [
      {
        type: "raw",
        format: "plain",
        data:
          "\x1B\x40" + // Initialize printer
          "Printer connection successfull.\n\n" +
          "Thank you!\n\n\n" +
          "\x1D\x56\x41\x10", // Full paper cut
      },
      {
        type: 'raw',
        format: 'hex',
        data: cashDrawerCommand
      }
    ];

    await qz.print(config, data);
  } catch (err) {
    console.log("err", err);
    showNotification(err.message);
  }
}

const printData = async (base64DataPrint, settingsData, showNotification, shouldOpenCashDrawer = false) => {
  try {
    const config = getPrinterConfig(settingsData);

    if (!config) {
      showNotification("No printer name provided. Please, check printer settings");
      return;
    }

    const data = [
      {
        type: "raw",
        format: "base64",
        data: base64DataPrint, // your base64 string from backend
      },
    ];

    if (shouldOpenCashDrawer && settingsData?.cashDrawerCommand) {
      // data.push({type: 'raw', format: 'plain', data: "\x1B\x70\x00\x40\x50"});
      data.push({type: 'raw', format: 'hex', data: settingsData.cashDrawerCommand});
    }

    await qz.print(config, data);
  } catch (err) {
    console.error("Print failed:", err);
  }
};

/**
 * It is used both for manual and auto print
 * Common required data
 * base64PrintData
 * printerName in the respective printer settings
 *
 * Auto Print required data
 *  respective invoice or kitchen slip printer settings should have isAutoPrint true
 *  isDeviceUsedAsAutoPrintInvoice or isDeviceUsedAsAutoPrintKitchenSlip should be true
 *
 * Currently there is no scope to miss base64PrintData but
 * printerName and isAutoPrint have some cases
 * Case1: A restaurant may not have printer settings in that case printerSettingsInvoice and isDeviceUsedAsAutoPrintKitchenSlip
 * Case 2: A restaurant may have partial printer settings
 * Case 3: A restaurant may have configured printer settings from anroid but not for web.
 *
 * @param {*} socketData
 * @param {*} showNotification
 * @param {*} isAutoPrint
 * @returns
 */
export const processAndPrint = (socketData, showNotification, isAutoPrint = true) => {
  // get device id from state as localstorage
  let isDeviceUsedAsAutoPrintInvoice = "";
  let isDeviceUsedAsAutoPrintKitchenSlip = "";
  const generalStorage = localStorage.getItem("general-storage");

  if (generalStorage) {
    const tmp = JSON.parse(generalStorage);
    isDeviceUsedAsAutoPrintInvoice = tmp.state.isDeviceUsedAsAutoPrintInvoice;
    isDeviceUsedAsAutoPrintKitchenSlip = tmp.state.isDeviceUsedAsAutoPrintKitchenSlip;
  }

  const { printerSettingsInvoice = {}, printerSettingsKitchenSlip = {} } = socketData.printerSettings;
  const {paymentReceiveTypes} = socketData.record;
  const { base64DataPrint, paymentStatus } = socketData;
  let printPurpose = socketData.printPurpose || "";

  printPurpose = printPurpose.split(",");
  printPurpose = printPurpose.map((text) => text.trim()).filter((text) => text !== "");

  const hasPurposeInvoice = printPurpose.includes("INVOICE");
  const hasPurposeKitchenSlip = printPurpose.includes("KITCHEN_SLIP");

  // Guest bill will not be auto print but 
  if (
    isAutoPrint &&
    printerSettingsInvoice?.isAutoPrint &&
    isDeviceUsedAsAutoPrintInvoice &&
    hasPurposeInvoice
    //  &&
    // paymentStatus === 1
  ) {
    // Auto print Invoice
    console.log('========paymentReceiveTypes======', {paymentReceiveTypes, socketData});
    const cashDrawerOpen = paymentReceiveTypes.some(item => item.paymentReceiveType === 'CASH');

    printData(base64DataPrint.invoice, printerSettingsInvoice, showNotification, cashDrawerOpen);
  }

  if (
    isAutoPrint &&
    printerSettingsKitchenSlip?.isAutoPrint &&
    isDeviceUsedAsAutoPrintKitchenSlip &&
    hasPurposeKitchenSlip
  ) {
    // Auto print Kitchen Slip
    printData(base64DataPrint.kitchenSlip, printerSettingsKitchenSlip, showNotification);
  }

  if (isAutoPrint) {
    return;
  }

  //Manual print start from here
  if (hasPurposeInvoice) {
    printData(base64DataPrint.invoice, printerSettingsInvoice, showNotification);
  }

  if (hasPurposeKitchenSlip) {
    printData(base64DataPrint.kitchenSlip, printerSettingsKitchenSlip, showNotification);
  }
};

export const processAndPrintSalesSummary = (socketData, showNotification) => {
  // get device id from state as localstorage
  let isDeviceUsedAsAutoPrintInvoice = "";
  const generalStorage = localStorage.getItem("general-storage");

  if (generalStorage) {
    const tmp = JSON.parse(generalStorage);
    isDeviceUsedAsAutoPrintInvoice = tmp.state.isDeviceUsedAsAutoPrintInvoice;
  }

  const { printerSettingsInvoice = {} } = socketData.printerSettings;
  const { base64DataPrint } = socketData;
  
  if (isDeviceUsedAsAutoPrintInvoice) {
    printData(base64DataPrint.salesSummary, printerSettingsInvoice, showNotification, false);
  }
};